module.exports = __webpack_public_path__ + "static/img/smallBase.5e1b5a05.png";